<template>
  <div class="gantt-wrapper-cust">
    <div class="gantt-wrapper-cust-in" ref="ganttContainer" />    
  </div>
</template>

<script>
import clone from 'lodash.clonedeep';
import moment from 'moment';
import { SVGGantt, CanvasGantt, StrGantt } from 'gantt';

export default {
  mounted() {
    this.init();
  },
  props: {
    series: { // project_id
      type: Array,
      requred: true
    }
  },
  data() {
    return {
      chart: null,
    //   data:
    };
  },
  components: {
  },
  computed: {
    
  },
  watch: {
    series: {
      deep: true,
      handler() {
        this.update();
      }
    }
  },
  methods: {
    init() {  
      if (!this.series) return false;
      if (this.chart) return true;  
      this.chart = new SVGGantt(this.$refs.ganttContainer, this.series, {
        viewMode: 'week'
      });
    },    
    update() {      
      if (!this.init()) return;
      this.chart.setData(this.series);
      this.chart.render();
    }
  }
};

</script>

<style scoped lang=scss>
    .gantt-wrapper-cust {
	    max-width: 100rem;
        overflow-x: auto;
        /* margin: 5px;  */
    }
    .gantt-wrapper-cust  svg {
        /* margin-bottom: 2.5em;
        min-width: 100%; */
        /* width:100%; */
        /* border: solid 2px green;   
        position:relative;       
        box-sizing: content-box;
        margin: 5px;  */
        /* width:100%;
        overflow: scroll;  
        border: solid 1px red;    */
           /* display: inline-block;
        width: 100%;
        overflow: scroll; 
        border: solid 1px red;       
        margin: 5px; */
    }
</style>
